import { ActivatedRoute, RouterLink } from '@angular/router';
import { tap, switchMap } from 'rxjs/operators';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { App } from 'src/app/models/app';
import { LayoutService } from '../layout.service';
import * as g from 'src/app/globals';
import {
  Category,
  Page,
} from 'src/app/apps/website/interfaces/PagesCategories';
import { WebsiteService } from 'src/app/apps/website/website.service';
import { Menu } from 'src/app/models/menu';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.less'],
})
export class AppMenuComponent implements OnInit {
  @Input() app: App;
  @Input() direction = 'horizontal';
  urlSuffix = g.getUrlSuffix();
  urlPrefix = g.apiBaseUrl;
  appName = '';
  menus: Menu[] = [];
  @Output() menuSelected: EventEmitter<boolean> = new EventEmitter(true);
  pages: Page[] = [];
  categories: Category[] = [];
  screenSize: string;
  constructor(
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private websiteService: WebsiteService
  ) {
    this.screenSize = layoutService.screenSize;
    layoutService.screenSizeEmitter.subscribe((size: string) => {
      this.screenSize = size;
    });
  }

  ngOnInit(): void {
    this.appName = this.route.snapshot.data.app;
    this.menus = this.app.menus;
    this.websiteService
      .getPages()
      .pipe(
        tap((pages) => {
          this.pages = pages;
        }),
        switchMap(() => this.websiteService.getCategories()),
        tap((categories) => {
          this.categories = categories;
          this.handleMenus();
        })
      )
      .subscribe();
  }

  menuClicked(): void {
    this.menuSelected.emit(true);
  }

  getMenuUrl(menu: Menu): any {
    return Menu.getMenuUrl(menu);
  }

  handleMenus() {
    this.pages.forEach((page) => {
      const inMain = page.AdditionalInformationParsed.InMainMenu;
      if (inMain != null && inMain === true) {
        this.menus.push({
          Icon: page.AdditionalInformationParsed.Icon,
          ParentMenu: this.app.parentMenuId,
          SortOrder: page.AdditionalInformationParsed.SortOrder,
          Type: 1,
          Label: page.Title,
          ChildMenus: [],
          Url: `/apps/${this.appName}/pages/${page.Code}`,
        });
      } else {
        const category = this.categories.find(
          (x) => x.Code.toLowerCase() === page.CategoryCode.toLowerCase()
        );
        if (category != null) {
          if (this.menus.findIndex((x) => x.Label === category.Title) === -1) {
            const pages = this.pages.filter(
              (x) =>
                x.CategoryCode.toLowerCase() === category.Code.toLowerCase() &&
                !x.AdditionalInformationParsed.InMainMenu
            );
            const npages = pages
              .map((x) => {
                const menu: Menu = {
                  Icon: x.AdditionalInformationParsed.Icon,
                  Label: x.Title,
                  ParentMenu: category.Code,
                  SortOrder: x.AdditionalInformationParsed.SortOrder,
                  Type: 1,
                  ChildMenus: [],
                  Url: `/apps/${this.appName}/pages/${page.Code}`,
                };

                return menu;
              })
              .sort((x, y) => x.SortOrder - y.SortOrder);

            this.menus.push({
              Icon: category.AdditionalInformationParsed.Icon,
              Label: category.Title,
              ParentMenu: this.app.parentMenuId,
              SortOrder: category.AdditionalInformationParsed.SortOrder,
              Type: 2,
              ChildMenus: npages,
              Url: '',
            });
          }
        }
      }
      this.menus = this.menus.sort((a, b) => a.SortOrder - b.SortOrder);
    });
  }
}
